import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { HarmonicsTable } from 'sharedComponents';
import { setMaxPrecision } from 'helpers/formatters';
import { MAX_PRECISION } from '../constants';

function SpeedHarmonicsTable(props) {
    const {
        harmonics,
        frequencyUnitSymbol,
        harmonicsHighestPeaks,
        precision
    } = props;

    const effectivePrecision = typeof precision === 'number' ? precision : MAX_PRECISION;

    const highestPeaksData = harmonicsHighestPeaks?.map((peak, index) => {
        const value = typeof peak.frequencyValue === 'number'
            ? setMaxPrecision(peak.frequencyValue, effectivePrecision)
            : peak.frequencyValue;
        const magnitude = typeof peak.magnitude === 'number'
            ? setMaxPrecision(peak.magnitude, effectivePrecision)
            : peak.magnitude;

        return {
            value,
            magnitude,
            name: peak.order ? `${peak.order}` : String(index + 1)
        };
    }) ?? [];

    return (
        <div className='speed-harmonics-table-container'>
            <HarmonicsTable
                title={translate('ABB.Powertrain.Frontend.speedHarmonicsLabel')}
                data={harmonics || []}
                frequencyUnitSymbol={frequencyUnitSymbol}
            />
            {highestPeaksData.length > 0 && harmonics?.length > 0 &&
                <HarmonicsTable
                    title={translate('ABB.Powertrain.Frontend.highestPeaksLabel')}
                    data={highestPeaksData}
                    frequencyUnitSymbol={frequencyUnitSymbol}
                />
            }
        </div>
    );
}

SpeedHarmonicsTable.propTypes = {
    harmonics: PropTypes.array,
    harmonicsHighestPeaks: PropTypes.array,
    frequencyUnitSymbol: PropTypes.string,
    precision: PropTypes.number
};

export default SpeedHarmonicsTable;
